import React, { FC } from 'react';
import { Template } from './components/Template/Template';
import s from './TemplatesGrid.scss';
import { templatesGridDataHooks } from './TemplatesGrid.dataHooks';
import { useTemplates } from '../../hooks/useTemplates';

export const TemplatesGrid: FC = () => {
  const templates = useTemplates();
  const numOfTemplatesInViewport = 6;

  return (
    <div
      data-hook={templatesGridDataHooks.templatesGrid()}
      className={s.templates}
    >
      {templates?.map((template, index) => (
        <Template
          key={template.templateId}
          template={template}
          isLazyLoad={index > numOfTemplatesInViewport}
          index={index}
        />
      ))}
    </div>
  );
};
